import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

const imageCardField = [
  imageField('media'),
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'body',
    type: 'richText',
  },
] as const satisfies DeepReadonly<Input[]>;

const imageCardConfig = {
  name: 'card',
  inputs: imageCardField,
};

export type CardConfigProps = GenerateBuilder<typeof imageCardField>;

export default imageCardConfig;
